import { render, staticRenderFns } from "./linked-maintenance-collapsible.vue?vue&type=template&id=3d95dcbc"
import script from "./linked-maintenance-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./linked-maintenance-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-maintenance-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d95dcbc')) {
      api.createRecord('3d95dcbc', component.options)
    } else {
      api.reload('3d95dcbc', component.options)
    }
    module.hot.accept("./linked-maintenance-collapsible.vue?vue&type=template&id=3d95dcbc", function () {
      api.rerender('3d95dcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/linked-external-ids-collapsible/linked-maintenance-collapsible/linked-maintenance-collapsible.vue"
export default component.exports